import { NgClass } from "@angular/common";
import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { TagType } from "./tag.type";
import { TAG_TYPE_CLASS } from "./tag-type.const";

@Component({
  selector: "lib-tag",
  standalone: true,
  imports: [NgClass],
  templateUrl: "./tag.component.html",
  styleUrl: "./tag.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TagComponent {
  @Input() text!: string;
  @Input() type?: TagType;

  public getTagClass(type?: string | null | undefined): string {
    type = type ? type : "default";
    return TAG_TYPE_CLASS[type];
  }
}
